import { getSDKConfig } from './getSDKConfig';

export const isNewMenuEnabled = (): boolean =>
  getSDKConfig()?.swipeGames?.swipeIconCollapse?.enableCollapseMenu ?? false;

export const isIconCollapseEnabled = (): boolean =>
  getSDKConfig()?.swipeGames?.swipeIconCollapse?.enabled ?? false;
